



























































import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import OutdoorDisplayMixin from './OutdoorDisplayMixin.vue'

@Component({
  components: {},
})
export default class OutdoorDisplay extends mixins(OutdoorDisplayMixin) {}
